import { render, staticRenderFns } from "./thePatent.vue?vue&type=template&id=6c201c4e&scoped=true&"
import script from "./thePatent.vue?vue&type=script&lang=js&"
export * from "./thePatent.vue?vue&type=script&lang=js&"
import style0 from "./thePatent.vue?vue&type=style&index=0&id=6c201c4e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c201c4e",
  null
  
)

export default component.exports